import constants from 'utils/constants';

export function ToTitleCase(text) {
    if (!text) {
        return '';
    }
    let str = text.replace(/([^\W_]+[^\s-]*) */g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

    // Certain minor words should be left lowercase unless
    // they are the first or last words in the string
    const lowers = [
        'A',
        'An',
        'The',
        'And',
        'But',
        'Or',
        'For',
        'Nor',
        'As',
        'At',
        'By',
        'For',
        'From',
        'In',
        'Into',
        'Near',
        'Of',
        'On',
        'Onto',
        'To',
        'With',
        'Le',
        'Et',
        'Pour',
        'De',
    ];
    for (let i = 0, j = lowers.length; i < j; i++) {
        str = str.replace(new RegExp('\\s' + lowers[i] + '\\s', 'g'), (txt) => txt.toLowerCase());
    }

    // Certain words such as initials or acronyms should be left uppercase
    const uppers = ['Id', 'Tv', 'Rb', 'Iii', 'Ii'];
    for (let i = 0, j = uppers.length; i < j; i++) {
        str = str.replace(new RegExp('\\b' + uppers[i] + '\\b', 'g'), uppers[i].toUpperCase());
    }

    return str;
}

const alreadyAcronym = ['BMG', 'PRS', 'RBM', 'RB'];

export function ToAcronym(text) {
    if (text === null) {
        return '';
    }
    if (text.split(' ').length < 1) {
        return text;
    }
    if (text.toLowerCase().includes('sony')) {
        return 'SATV';
    }
    for (const acr of alreadyAcronym) {
        if (text.startsWith(acr)) {
            return acr;
        }
    }
    return text.replace(/([0-9A-Za-z\u00C0-\u017F])[0-9A-Za-z\u00C0-\u017F]*\W*/g, (_, i) => i.toUpperCase());
}

const majorPublishers = [
    'Big Deal',
    'BMG',
    'Concord',
    'Italian Way',
    'Kobalt',
    'Memory Lane',
    'Native Tongue',
    'Primary Wave',
    'Reservoir',
    'Round Hill',
    'Royalty Network',
    'Sentric',
    'Spirit',
    'Sub Pop',
    'Supreme Songs',
    'Warp',
];

export function toShortPublisherName(text) {
    if (text === null) {
        return '';
    }
    if (text.split(' ').length < 1) {
        return text;
    }
    if (text.toLowerCase().includes('sony')) {
        return 'SONY/ATV';
    }
    if (text.toLowerCase().includes('universal')) {
        return 'UMPG';
    }
    if (text.toLowerCase().includes('warner')) {
        return 'WARNER CHAPPELL';
    }
    for (const pub of majorPublishers) {
        if (text.toLowerCase().includes(pub.toLowerCase())) {
            return pub.toUpperCase();
        }
    }
}

export function removeSpecialChars(text) {
    return text.replace(/[^a-zA-Z0-9]/g, '');
}

export function capitalizeWords(str) {
    return str ? str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()) : str;
}

export function transformEntityName(name, entityType) {
    return name ? (entityType === constants.EntityType.WRITER ? ToTitleCase(name) : name.toUpperCase()) : '—';
}

// convert array like [1,2,3,4] to english language list like 1, 2, 3 and 4
export function toCommaListAndLastElement(array) {
    return array.length > 1
        ? array
              .slice(0, array.length - 1)
              .join(', ')
              .concat(' and ', array[array.length - 1])
        : array;
}

export function levenshteinDistance(a, b) {
    if (a.length === 0) {
        return b.length;
    }
    if (b.length === 0) {
        return a.length;
    }

    const matrix = [];

    // increment along the first column of each row
    for (let i = 0; i <= b.length; i++) {
        matrix[i] = [i];
    }

    // increment each column in the first row
    for (let j = 0; j <= a.length; j++) {
        matrix[0][j] = j;
    }

    // Fill in the rest of the matrix
    for (let i = 1; i <= b.length; i++) {
        for (let j = 1; j <= a.length; j++) {
            if (b.charAt(i - 1) === a.charAt(j - 1)) {
                matrix[i][j] = matrix[i - 1][j - 1];
            } else {
                matrix[i][j] = Math.min(
                    matrix[i - 1][j - 1] + 1, // substitution
                    Math.min(
                        matrix[i][j - 1] + 1, // insertion
                        matrix[i - 1][j] + 1, // deletion
                    ),
                );
            }
        }
    }

    return matrix[b.length][a.length];
}

// a function to format an array of strings into a single string,
// truncated for a maximum nunber of items,
// joined by a separator and ending with an ellipsis
export function truncateItems(array, maxItems, separator) {
    if (array.length > maxItems) {
        return array.slice(0, maxItems).join(separator) + '…';
    }
    return array.join(separator);
}
